import {JSX, lazy} from "react";
import DashboardPage from "../pages/Dashboard/DashboardPage";
import SyariahInterventionPage from "../pages/SyariahIntervention";
import PatientList from "../pages/Patients/PatientList";
import PatientDetail from "../pages/Patients/PatientDetail";
import VisitsPage from "../pages/Visits/VisitsPage";
import VisitDetail from "../pages/Visits/VisitDetailPage";
import UserManagement from "../pages/Users/UserManagementPage";
import ProtectedRoute from "./ProtectedRoute";

const Login = lazy(() => import("../pages/Authentication/LoginCover"));

export interface RouteType {
  path: string;
  element: JSX.Element;
  layout: "default" | "blank";
}

export const routes: RouteType[] = [
  {
    path: "/",
    element: (
        <ProtectedRoute>
          <DashboardPage />
        </ProtectedRoute>
    ),
    layout: "default",
  },
  {
    path: "/syariah-interventions",
    element: (
        <ProtectedRoute>
          <SyariahInterventionPage />
        </ProtectedRoute>
    ),
    layout: "default",
  },
  {
    path: "/patients",
    element: (
        <ProtectedRoute>
          <PatientList />
        </ProtectedRoute>
    ),
    layout: "default",
  },
  {
    path: "/patients/:id",
    element: (
        <ProtectedRoute>
          <PatientDetail />
        </ProtectedRoute>
    ),
    layout: "default",
  },
  {
    path: "/visits",
    element: (
        <ProtectedRoute>
          <VisitsPage />
        </ProtectedRoute>
    ),
    layout: "default",
  },
  {
    path: "/visits/:visitId",
    element: (
        <ProtectedRoute>
          <VisitDetail />
        </ProtectedRoute>
    ),
    layout: "default",
  },
  {
    path: "/user-management",
    element: (
        <ProtectedRoute>
          <UserManagement />
        </ProtectedRoute>
    ),
    layout: "default",
  },
  // Halaman Login (tidak perlu proteksi)
  {
    path: "/login",
    element: <Login />,
    layout: "blank",
  },
];
